var _excluded = ["as", "children", "className", "createChildProps", "disabled", "error", "isAssertiveError", "label", "marginBottom", "marginLeft", "marginRight", "marginTop", "name", "optional", "supportiveText", "tooltip"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import FieldError from "../FieldError";
import FieldLabel from "../FieldLabel";
import SupportiveText from "../SupportiveText";
import StyledLabeledField from "./styled";
/**
 * Component pattern which is used by most other form field components,
 * such as TextField, Dropdown and RadioButtonGroup.
 **/
var LabeledField = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    children = _ref.children,
    className = _ref.className,
    _ref$createChildProps = _ref.createChildProps,
    createChildProps = _ref$createChildProps === void 0 ? true : _ref$createChildProps,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    error = _ref.error,
    isAssertiveError = _ref.isAssertiveError,
    label = _ref.label,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? '07' : _ref$marginBottom,
    _ref$marginLeft = _ref.marginLeft,
    marginLeft = _ref$marginLeft === void 0 ? 'none' : _ref$marginLeft,
    _ref$marginRight = _ref.marginRight,
    marginRight = _ref$marginRight === void 0 ? 'none' : _ref$marginRight,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? 'none' : _ref$marginTop,
    name = _ref.name,
    _ref$optional = _ref.optional,
    optional = _ref$optional === void 0 ? false : _ref$optional,
    supportiveText = _ref.supportiveText,
    tooltip = _ref.tooltip,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledLabeledField, _extends({
    $marginBottom: marginBottom,
    $marginLeft: marginLeft,
    $marginRight: marginRight,
    $marginTop: marginTop
  }, rest, {
    "aria-describedby": as === 'fieldset' ? "".concat(name, "-hint ").concat(name, "-error") : undefined,
    as: as,
    className: classNames(children && 'csl-field', className),
    ref: ref
  }), /*#__PURE__*/React.createElement(FieldLabel, {
    "aria-describedby": as === 'fieldset' ? undefined : "".concat(name, "-hint ").concat(name, "-error"),
    as: as === 'fieldset' ? 'legend' : 'label',
    htmlFor: as === 'fieldset' ? undefined : name,
    optional: optional
  }, label), /*#__PURE__*/React.createElement(SupportiveText, {
    id: "".concat(name, "-hint")
  }, supportiveText), tooltip && /*#__PURE__*/React.createElement(SupportiveText, null, tooltip), /*#__PURE__*/React.createElement(FieldError, {
    id: "".concat(name, "-error"),
    isAssertive: isAssertiveError
  }, error), children && React.Children.map(children, function (child) {
    var _props, _props2;
    return /*#__PURE__*/React.cloneElement(child, createChildProps ? {
      'aria-describedby': "".concat(name, "-hint ").concat(name, "-error"),
      disabled: (child === null || child === void 0 ? void 0 : (_props = child.props) === null || _props === void 0 ? void 0 : _props.disabled) !== undefined ? child === null || child === void 0 ? void 0 : (_props2 = child.props) === null || _props2 === void 0 ? void 0 : _props2.disabled : disabled,
      error: Boolean(error)
    } : {});
  }));
});
LabeledField.displayName = 'LabeledField';
export default LabeledField;